var availableCollections;
var availableCollectionsArray;
var availableCollectionsArrayLength = 0;
var availableCollectionsLoadCount = 0;
var jsonOptions = '';
var colorData = {};
var colorSelectorDataList;
var colorSelectorInput;
var customColorInput;
var customColorToggle;
var colorSelectorContainer;
var currentColorCollections = '';
var defaultColorCollectionsOrderArray = ['untinted','wsc','wsct','bmc','cp','af','cc','csp','ac','hc','oc','cw','sc'];
var documentLang = document.documentElement.lang;
if(documentLang == 'en-CA') {
  defaultColorCollectionsOrderArray = ['untinted','wsc','wsct','bmc','cp','af','cc','csp','hc','oc','sc'];
}
function loadJSONOptions (collection) {
  if(collection) {
    getColorCollection('/collections/' + collection + '?view=colors',collection);
  }
}

function updateColorOptions() {
  colorSelectorDataList = document.getElementById('colors-datalist');
  colorSelectorInput = document.getElementById('color');
  colorSelectorContainer = document.getElementById('color-selector');
  if(colorSelectorContainer) {
    colorSelectorContainer.classList.remove('hidden');
    colorSelectorInput.classList.add('required');
    setupColorSelectorInput();
    colorSelectorInput.required = true;
    if (typeof productColorCollections !== 'undefined') {
      availableCollections = productColorCollections;
      
      if (typeof availableCollections !== 'undefined') {
        if(availableCollections !== currentColorCollections) {
          currentColorCollections = availableCollections;
          availableCollectionsArray = availableCollections.split('|');
          availableCollectionsArray.sort(function(a, b){  
            return defaultColorCollectionsOrderArray.indexOf(a) - defaultColorCollectionsOrderArray.indexOf(b);
          });
          availableCollectionsArray = availableCollectionsArray.filter(function(e) { return e !== '' })
          availableCollectionsLoadCount = 0;
          availableCollectionsArrayLength = availableCollectionsArray.length;
          jsonOptions = '';
          colorSelectorDataList.innerHTML = '';
          clearColor();
          colorSelectorInput.placeholder = "Search Color";
          if(sessionStorage.getItem('colorData')) {
            colorData = JSON.parse(sessionStorage.getItem('colorData'));
          }
          getColorsCustom();
          loadJSONOptions(availableCollectionsArray[0]);
        }
      }
      if(availableCollections == '') {
        colorSelectorContainer.classList.add('hidden');
        colorSelectorInput.classList.remove('required');
        colorSelectorInput.required = false;
      }
    }
  }
}

function createOptions(item) {
  var optionElement = document.getElementById(item.handle);
  if (optionElement === null) {
    var option = document.createElement('option');
    option.id = item.handle;
    option.value = item.title;
    colorSelectorDataList.appendChild(option);
  }  
}

function clearColor() {
  colorSelectorInput.value = '';
  colorSelectorInput.classList.add('required');
  var colorSwatchLinkContainer = document.querySelector('span.color-swatch-link-container');
  colorSwatchLinkContainer.innerHTML = '';
}
function getColorsCustom() {
  if (typeof productColorsCustom !== 'undefined') {
    productColorsCustomArray = productColorsCustom.replace(/\|$/, '').split('|');
    productColorsCustomArray.forEach((value) => {
      var item = {};
      item.handle = value;
      item.title = value.charAt(0).toUpperCase() + value.slice(1);
      createOptions(item);
    });      
  }
}

function getColorCollection(collection_url,collection) {
  if (colorData[collection]) {
    addColorSelectorOptions(collection);
  } else {
    preloadDefaultColorCollections(collection_url,collection);
  }
}

function addColorSelectorOptions(collection) {
  if (typeof colorData[collection] !== 'undefined') {
    for (const [key, value] of Object.entries(colorData[collection])) {
      var item = {};
      item.handle = Object.keys(value)[0];
      item.title = Object.values(value)[0];
      createOptions(item);
    }
  }
  if(availableCollectionsArrayLength-1 > availableCollectionsLoadCount) {
    availableCollectionsLoadCount++;
    loadJSONOptions(availableCollectionsArray[availableCollectionsLoadCount]);
  }
}

function setupColorSelectorInput() {
  colorSelectorInput = document.getElementById('color');
  customColorInput = document.getElementById('custom-color');
  customColorToggle = document.getElementById('custom-color-toggle');
  if (colorSelectorInput) {
    //Update Color Swatch
    colorSelectorInput.addEventListener('change', (event) => {
      if (customColorInput) {
        customColorInput.value = '';
      }
      var targetErrors = event.target.parentNode.querySelector('div.errors');
      if (targetErrors !== null) {
        targetErrors.parentNode.removeChild(targetErrors);
      }
      var selectedProduct = document.querySelector('#colors-datalist option[value="'+event.target.value+'"]');
      if (selectedProduct == null) {
        event.target.value = '';
      } else {
        var selectedProductID = selectedProduct.getAttribute('id');
        var apiURL = '/products/' + selectedProductID + '.js';
        var request = new XMLHttpRequest();
        request.onreadystatechange = function(response) {
          if (request.readyState === 4) {
            if (request.status === 200) {
              var colorMeta = JSON.parse(request.responseText);
              var selectedProductImage = colorMeta.featured_image;
              var colorSwatchLinkContainer = document.querySelector('span.color-swatch-link-container');
              if(selectedProductImage == 'null') {
                colorSwatchLinkContainer.innerHTML = '';
              } else {
                var selectedProductValue = selectedProduct.getAttribute('value');
                var colorSwatchHTML = '';
                colorSwatchHTML += '<a href="' + '/products/' + selectedProductID + '" class="color-swatch-link">';
                colorSwatchHTML += '<span class="color-swatch"style="background-image: url(\''+selectedProductImage+'\');"></span>';
                colorSwatchHTML += '<span class="visually-hidden">View details on ' + selectedProductValue + '</span>';
                colorSwatchHTML += '</a>';
                colorSwatchLinkContainer.innerHTML = colorSwatchHTML;
              }
            } else {
              
            }
          }
        };
        request.open('GET', apiURL, true);
        request.send();
      }
    });

    colorSelectorInput.addEventListener('focusin', (event) => {
      clearColor();
    });

    if (typeof customPaintColor !== 'undefined') {
      if (customColorInput) {
        customColorInput.addEventListener('input', (event) => {
          clearColor();
          if(event.target.value !== '') {
            colorSelectorInput.value = '';
            colorSelectorInput.classList.remove('required');
            colorSelectorInput.required = false;
          } else {
            colorSelectorInput.classList.add('required');
            colorSelectorInput.required = true;
          }
        });
        customColorToggle.addEventListener('click', (event) => {
            document.getElementById('custom-color-input').classList.remove('visually-hidden');
            customColorToggle.classList.add('visually-hidden');
        });
      }
    }
  }
}
setupColorSelectorInput();

// Preload default color collections
var defaultColorCollectionsArray = [];
var defaultColorCollectionsArrayLength = 0;
var defaultColorCollectionsLoadCount = 0;

if(sessionStorage.getItem('defaultColorCollectionsArray')) {
  defaultColorCollectionsArray = JSON.parse(sessionStorage.getItem('defaultColorCollectionsArray'));
} else {
  defaultColorCollectionsArray = defaultColorCollectionsOrderArray;
}

window.addEventListener('load', (event) => {
  defaultColorCollectionsLoadCount = 0;
  defaultColorCollectionsArrayLength = defaultColorCollectionsArray.length;
  preloadDefaultColorCollectionsURL(defaultColorCollectionsArray[0]);
});

function preloadDefaultColorCollectionsURL (collection) {
  if(collection) {
    if(sessionStorage.getItem('colorData')) {
      colorData = JSON.parse(sessionStorage.getItem('colorData'));
      if(!colorData[collection]) {
        preloadDefaultColorCollections('/collections/' + collection + '?view=colors',collection);
      } else {
        defaultColorCollectionsLoadCount++;
        preloadDefaultColorCollectionsURL(defaultColorCollectionsArray[defaultColorCollectionsLoadCount]);
      }
    } else {
      preloadDefaultColorCollections('/collections/' + collection + '?view=colors',collection);
    }
  }
}

function preloadDefaultColorCollections(collection_url, collection) {
  var apiURL = collection_url;
  var request = new XMLHttpRequest();
  request.onreadystatechange = function (response) {
    if (request.readyState === 4) {
      if (request.status === 200) {
        jsonOptions = JSON.parse(request.responseText);
        jsonColors = jsonOptions.colors;
        jsonNextPage = jsonOptions.nextpage;
        jsonColors.forEach(function (item) {
          if (!colorData[collection]) {
            colorData[collection] = [];
          }
          itemObject = {};
          itemObject[item.handle] = item.title;
          colorData[collection].push(itemObject);
        });
        if (jsonOptions.nextpage !== "") {
          preloadDefaultColorCollections(jsonNextPage, collection);
          return; // more pages to load — don't advance yet
        }
      } else {
        // Collection missing (404) or request failed — skip it without
        // breaking the chain. Mark it as loaded-but-empty so
        // getColorCollection() never re-requests it this session.
        if (!colorData[collection]) {
          colorData[collection] = [];
        }
        var collectionIndex = defaultColorCollectionsArray.indexOf(collection);
        if (collectionIndex > -1) {
          defaultColorCollectionsArray.splice(collectionIndex, 1);
          if (collectionIndex <= defaultColorCollectionsLoadCount) {
            defaultColorCollectionsLoadCount--;
          }
          defaultColorCollectionsArrayLength = defaultColorCollectionsArray.length;
        }
        sessionStorage.setItem("defaultColorCollectionsArray", JSON.stringify(defaultColorCollectionsArray));
      }
      // Shared continuation — runs for both success and failure
      if (defaultColorCollectionsArrayLength - 1 > defaultColorCollectionsLoadCount) {
        defaultColorCollectionsLoadCount++;
        preloadDefaultColorCollectionsURL(defaultColorCollectionsArray[defaultColorCollectionsLoadCount]);
      } else {
        sessionStorage.setItem("colorData", JSON.stringify(colorData));
        if (typeof availableCollectionsArray !== "undefined") {
          loadJSONOptions(availableCollectionsArray[0]);
        }
      }
    }
  };
  request.open("GET", apiURL, true);
  request.send();
}